<template>
	<v-container fill-height>
		<v-row>
			<v-col cols="12">
				<v-row justify="center">
					<v-col cols="12" sm="10" lg="6">
						<v-card elevation="1" tag="section">
							<v-img
								class="white--text align-end"
								height="200px"
								src="https://i0.wp.com/ylh.org.hk/wp-content/uploads/2019/04/YLH_Poster_2019_Artwork_website_banner-01.jpg?resize=2000%2C1200&ssl=1"
							>
								<v-card-title>Zion Hub</v-card-title>
							</v-img>
							<v-card-title>
								<v-layout align-center justify-space-between>
									<v-img
										:alt="platformName"
										class="ml-3"
										contain
										height="48px"
										position="center center"
										src="https://i2.wp.com/ylh.org.hk/wp-content/uploads/2017/05/ylh_logo_2013b-png-1-e1495170476709.png?w=200&ssl=1"
									></v-img>
								</v-layout>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<p>Sign in with your username and password:</p>
								<v-form>
									<v-text-field
										outline
										label="Username"
										type="text"
										v-model="username"
									></v-text-field>
									<v-text-field
										v-if="mode == `login`"
										outline
										hide-details
										label="Password"
										type="password"
										v-model="password"
									></v-text-field>
									<v-text-field
										refs="email"
										v-if="mode == `forgot`"
										outline
										label="Email"
										type="text"
										v-model="email"
										hint="Please enter email to reset"
										persistent-hint
										required
									></v-text-field>
								</v-form>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions
								:class="{ 'pa-3': $vuetify.breakpoint.smAndUp }"
							>
								<v-btn
									v-if="mode == `login`"
									dark
									:large="$vuetify.breakpoint.smAndUp"
									@click="mode = `forgot`"
								>
									Forgot Password
								</v-btn>
								<v-btn
									v-if="mode == `forgot`"
									dark
									:large="$vuetify.breakpoint.smAndUp"
									@click="mode = `login`"
								>
									Back to login
								</v-btn>
								<v-btn
									dark
									:large="$vuetify.breakpoint.smAndUp"
									@click="goLogin"
								>
									Login
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import axios from "axios";
import router from "@/router";
export default {
	data() {
		return {
			mode: "login",
			darkTheme: true,
			platformName: "Zion hub",
			password: null,
			username: null,
			phone: null,
		};
	},
	methods: {
		goLogin() {
			let _self = this;
			var formData = new FormData();
			formData.append("username", _self.username);
			formData.append("password", _self.password);
			axios
				.post("https://secureim.ylh.org.hk/srv2/auth.php", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function(response) {
					let ecc = response.data;
					if (ecc.status == "ok") {
						localStorage.setItem("token", ecc.token);
						localStorage.setItem("is_admin", ecc.is_admin);
						router.push({ path: "/private/chat" });
					} else {
					}
				})
				.catch(function(error) {
					console.log(error);
				});
		},
	},
};
</script>
